import { createRoute } from "@tanstack/solid-router";
// FLAGS: la página entera se gatea por feature (org activa).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Receipt } from "lucide-solid";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { receiptUrl } from "@/features/finance/api";

export const receiptRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/finance/receipt/$paymentId",
  component: withFeatureGate("billing.core", ReceiptPage),
});

// Function declaration (hoisted) so `receiptRoute` above can reference it while
// the component reads params from the already-declared route.
function ReceiptPage() {
  const { t } = useI18n();
  const params = receiptRoute.useParams();
  return (
    <PageContainer maxWidth="3xl">
      <PageHeader title={t(msg`Receipt`)} backTo="/payments" icon={Receipt} />
      <div class="mt-4 overflow-hidden rounded-xl border border-border">
        <iframe
          src={receiptUrl(params().paymentId)}
          class="h-[70vh] w-full"
          title={t(msg`Receipt`)}
          sandbox="allow-scripts allow-modals allow-popups"
          data-testid="receipt-frame"
        />
      </div>
    </PageContainer>
  );
}
